<template>
  <div>
    <div class="items-ventajas-validacion">
      <ul>
        <li>Buscá un lugar bien iluminado</li>
        <li>Usá tu último DNI vigente</li>
        <li>No uses anteojos ni gorra</li>
      </ul>
    </div>
    <div class="center">
      <div class="images">
        <img class="SID" src="@/assets/img/logo_sid.png" alt="Ícono SID" />
      </div>
      <div class="buttons-container">
        <button @click="$emit('comenzar-validacion')" class="comenzar-btn">
          Comenzar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ValidationElement",
  data() {
    return {
      imagen: require(`@/assets/img/1x/camera.svg`)
    };
  }
};
</script>

<style scoped>
.box-init-validacion-identidad {
  text-align: center;
  max-width: 367px;
  padding: 24px;
  -webkit-box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.16);
  -moz-box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.16);
  box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.16);
}

.box-init-validacion-identidad strong {
  font-size: 17px;
}

.descripcion-validacion {
  font-size: 15px;
  line-height: 1.6;
  color: #121212;
}
.link-btn {
  font-size: 15px;
  line-height: 24px;
  color: #1973b8;
  text-decoration: none;
  background: none;
  border: none;
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  margin: 0;
}
.comenzar-btn {
  width: auto;
  position: relative;
  margin: 0 auto;
  background-color: #1973b8;
  height: 48px;
  border-radius: 1px;
  color: #ffffff;
  border: none;
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-stretch: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: center;
  min-width: 138px;
  cursor: pointer;
}

.items-ventajas-validacion {
  margin: 40px 0 50px 0;
}

.items-ventajas-validacion ul {
  margin: 0 0 72px;
  padding-left: 0;
  list-style: none;
}
.items-ventajas-validacion ul li {
  font-size: 14px;
  font-weight: bold;
  white-space: initial;
  margin-bottom: 15px;
  padding-left: 22px;
  background-image: url("../../assets/img/1x/li-azul.png");
  background-repeat: no-repeat;
  background-position: 0 3px;
}
p.presencial {
  font-size: 14px;
  font-weight: bold;
  white-space: initial;
  line-height: 18px;
  margin-top: 32px;
  margin-bottom: 8px;
}

.images {
  margin-bottom: 16px;
}
.buttons-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.buttons-container .link-btn {
  display: flex;
  justify-content: center;
  align-items: center;
}
.buttons-container .comenzar-btn {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
